// extracted by mini-css-extract-plugin
module.exports = {"FilterCheckbox":"DocumentFilterModalList_FilterCheckbox__1-UQ7","ScrollableContainer":"DocumentFilterModalList_ScrollableContainer__Dfe2U"};